export type AgentActivity = 'reading' | 'writing' | 'working';

const READING = new Set(['Read', 'Grep', 'Glob', 'NotebookRead']);
const WRITING = new Set(['Write', 'Edit', 'NotebookEdit']);

/** Coarse activity label for a sprite tell, derived from a tool_use name. */
export function activityFromToolUse(toolName: string): AgentActivity {
  if (READING.has(toolName)) return 'reading';
  if (WRITING.has(toolName)) return 'writing';
  return 'working';
}
